import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Link,
  Paper
} from "@mui/material";

import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";

const Service = () => {
  const publication = [
    {
      icon: <StackedBarChartIcon sx={{ fontSize: 40, color: "#6C63FF" }} />,
      title: "Infographic",
      description: "",
      href: "/doc?order=4"
    },
    {
      icon: <PermMediaIcon sx={{ fontSize: 40, color: "#6C63FF" }} />,
      title: "คลิป",
      description: "",
      href: "/media"
    },
    {
      icon: <SportsEsportsIcon sx={{ fontSize: 40, color: "#6C63FF" }} />,
      title: "เกม",
      description: "",
      href: "/doc?order=5"
    }
  ];

  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <section ref={ref} id="publication">
      <Container sx={{ py: 5, textAlign: "center", maxWidth: "md" }}>
        <Typography variant="h5" textAlign="center" gutterBottom>
          สื่อเผยแพร่
        </Typography>

        <Grid
          container
          spacing={4}
          justifyContent="center"
          sx={{ display: "flex", flexWrap: "wrap", mt: 3 }}
        >
          {publication.map((publication, index) =>
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <Card
                  elevation={3}
                  sx={{
                    width: "250px", // กำหนดความกว้างให้เท่ากัน
                    height: "120px", // กำหนดความสูงให้เท่ากัน
                    borderRadius: 4,
                    textAlign: "center",
                    padding: 3,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      transform: "scale(1.05)",
                      transition: "transform 0.3s ease-in-out"
                    },
                    cursor: "pointer"
                  }}
                  onClick={() => window.open(publication.href, "_self")}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      backgroundColor: "#E9EAFB",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 10px"
                    }}
                  >
                    {publication.icon}
                  </Box>

                  <CardContent>
                    <Typography variant="h7" gutterBottom>
                      {publication.title}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          )}
        </Grid>
      </Container>
    </section>
  );
};

export default Service;
